import React from 'react';
import ProgressDemo from '../components/ProgressDemo.tsx';
import UserProfileDisplay from '../components/UserProfileDisplay.tsx';

const TestPage: React.FC = () => {
    return (
        <div className="min-h-screen bg-gray-100 p-8">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-3xl font-bold text-center mb-8" style={{ fontFamily: 'Feather Bold' }}>
                    User Data Test Page
                </h1>

                <div className="grid md:grid-cols-2 gap-8">
                    <div>
                        <h2 className="text-xl font-bold mb-4">User Profile</h2>
                        <UserProfileDisplay />
                    </div>

                    <div>
                        <h2 className="text-xl font-bold mb-4">Progress Demo</h2>
                        <ProgressDemo />
                    </div>
                </div>

                <div className="mt-8 p-6 bg-white rounded-lg shadow">
                    <h3 className="text-lg font-bold mb-4">How to Use</h3>
                    <div className="space-y-2 text-sm">
                        <p><strong>1. Welcome Page:</strong> New users are redirected to set up their profile</p>
                        <p><strong>2. Progress Tracking:</strong> Use the demo buttons to test progress tracking</p>
                        <p><strong>3. Local Storage:</strong> All data is stored in your browser's localStorage</p>
                        <p><strong>4. Integration:</strong> Use the utility functions in any component to update progress</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TestPage;
